<div class="acumulados-view" *ngIf="!loading || patient">
  <h1 class="acumulados-title">{{ 'ACUMULADOS.TITLE' | translate }}</h1>

  <!-- Datos Paciente (mismo componente que detalle de petición) -->
  <section class="acumulados-section" *ngIf="patient">
    <afoone-patient-data [patient]="patient"></afoone-patient-data>
  </section>

  <!-- Tabla Peticiones (acumulados): bloque 1500px; mensaje SP sustituye la tabla en el mismo hueco -->
  <section
    class="acumulados-section acumulados-peticiones-section"
    *ngIf="patient && (requestColumns.length || messageInfo)"
  >
    <div class="acumulados-section-header">
      <h2 class="acumulados-section-label">{{ 'ACUMULADOS.PETICIONES' | translate }}</h2>
      <p-button
        *ngIf="canExportCsv"
        label="Exportar CSV"
        icon="pi pi-download"
        styleClass="acumulados-export-button"
        (onClick)="exportCsv()"
      ></p-button>
    </div>
    <div class="peticiones-table-wrapper" *ngIf="requestColumns.length && !messageInfo">
      <table
        class="peticiones-table"
        [style.--acum-requis-cols]="acumRequisColsVar"
      >
        <thead>
          <tr>
            <th scope="col" class="col-fixed col-tecnica">{{ 'REQUEST_DATA.TEST.TECNICA' | translate }}</th>
            <th scope="col" class="col-fixed col-unidades">{{ 'REQUEST_DATA.TEST.UNIDADES' | translate }}</th>
            <th *ngFor="let col of requestColumns" scope="col" class="col-requis" [class.origin]="col.isOrigin">
              <div class="col-header">
                <span class="col-header-date">{{ col.entryDate }}</span>
                <a class="col-header-id" (click)="openRequestResults(col)" href="javascript:void(0)">{{ col.requisNr }}</a>
                <span class="col-header-ext">({{ col.extRequisNr }})</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of testRows" [class.row-title]="row.isTitle" [class.row-disabled]="!row.isTitle && !row.hasAnyResult">
            <td class="col-fixed col-tecnica">
              <span class="cell-text" [title]="row.testName">{{ row.testName }}</span>
            </td>
            <td class="col-fixed col-unidades">
              <span class="cell-text" [title]="row.units">{{ row.units }}</span>
            </td>
            <td *ngFor="let cell of row.cells" class="col-requis cell-result">
              <span *ngIf="!row.isTitle" class="cell-text" [class.pathology-colored]="getPathologyColor(cell.pathology)" [style.--pathology-color]="getPathologyColor(cell.pathology)" [pTooltip]="cellTooltipText(cell.result, cell.normalRange)" tooltipPosition="top">{{ cell.result }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="peticiones-message-wrapper" *ngIf="messageInfo">
      <p-message severity="info" [text]="'ACUMULADOS.' + messageInfo | translate"></p-message>
    </div>
  </section>
  <!-- WIR-EF-03.01.6.6 / #502: navegación visible aunque solo haya mensaje (sin ocultar el otro sentido) -->
  <div class="acumulados-actions" *ngIf="showAcumuladosNav">
    <p-button
      label="{{ 'ACUMULADOS.VER_POSTERIORES' | translate }}"
      (onClick)="verPosteriores()"
      [loading]="loading"
      icon="pi pi-arrow-left"
      styleClass="acumulados-nav-button"
    ></p-button>
    <p-button
      label="{{ 'ACUMULADOS.VER_ANTERIORES' | translate }}"
      (onClick)="verAnteriores()"
      [loading]="loading"
      icon="pi pi-arrow-right"
      iconPos="right"
      styleClass="acumulados-nav-button"
    ></p-button>
  </div>

  <p-message *ngIf="error" severity="error" [text]="error"></p-message>
</div>

<p-progressBar *ngIf="loading && !patient" mode="indeterminate"></p-progressBar>
